import { TalkhattabatConversationType } from "../../../../../Types";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabatBulkMessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/bulk-messaging-store";
import InputField from "./InputField";
import SendButton from "./SendButton";

const InputFields = withLiteObserverAndTheme<{
  conversationType: TalkhattabatConversationType;
}>((props) => {
  const { conversationType } = props;
  const shouldShowConversations =
    getKhattabatBulkMessagingStore().isOpenedBulkMessagesBox.get();

  return !shouldShowConversations ? null : (
    <ET3Div
      width={1200}
      height={0}
      alignItems={"flex-start"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      {Array.from({ length: 10 }, (_, index) => index).map((index) => {
        return <InputField key={index} index={index} />;
      })}
      <SendButton conversationType={conversationType} />
    </ET3Div>
  );
});

export default InputFields;
